
export default function WhistlerLicensing() {
  const steps = [
    {
      number: '01',
      title: 'Verify Zoning Status',
      description: 'Confirm your property is in a Tourist Accommodation (TA) zone using the RMOW zoning map or by contacting planning services.',
      icon: 'ri-map-pin-line'
    },
    {
      number: '02',
      title: 'Check Strata Rules',
      description: 'Review your strata bylaws for any additional STR restrictions. Many buildings have rental pool requirements or management rules.',
      icon: 'ri-building-line'
    },
    {
      number: '03',
      title: 'Register with BC Registry',
      description: 'Complete provincial STR registration to obtain your BC registry number, required for all short-term rental operations.',
      icon: 'ri-government-line'
    },
    {
      number: '04',
      title: 'Apply for Business License',
      description: 'Submit your application through the Resort Municipality of Whistler with proof of ownership and registry number.',
      icon: 'ri-file-text-line'
    },
    {
      number: '05',
      title: 'Pay License Fee',
      description: 'Pay the annual $350 business license fee. Additional fees may apply for properties with multiple units.',
      icon: 'ri-bank-card-line'
    },
    {
      number: '06',
      title: 'Display License Numbers',
      description: 'Include both your RMOW business license and BC registry number on all booking platform listings.',
      icon: 'ri-price-tag-3-line'
    }
  ];

  return (
    <section id="licensing" className="py-24 lg:py-32 bg-[#F8F8F8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Licensing Process
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            How to Get Licensed in Whistler
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Follow these steps to legally operate your Whistler STR and maximize your rental potential in this world-class resort destination.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((step) => (
            <div
              key={step.number}
              className="bg-white rounded-2xl p-8 hover:shadow-lg transition-all relative overflow-hidden"
            >
              <div className="absolute top-4 right-4 text-6xl font-bold text-[#882629]/5">
                {step.number}
              </div>
              <div className="relative z-10">
                <div className="w-12 h-12 bg-[#882629] rounded-xl flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-xl font-semibold text-[#505A5A] mb-3">{step.title}</h3>
                <p className="text-[#505A5A]/70 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl p-8 lg:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="w-16 h-16 bg-[#882629]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-3xl text-[#882629]"></i>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-2">Important Compliance Note</h3>
              <p className="text-[#505A5A]/70 leading-relaxed">
                Whistler actively monitors booking platforms and enforces STR regulations. Operating without proper licensing in non-TA zones can result in fines starting at $1,000 per day. The municipality also works with platforms to remove non-compliant listings. Properties in TA zones with proper licensing enjoy full operational flexibility.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
